import { render, staticRenderFns } from "./awards.vue?vue&type=template&id=822e5c88&scoped=true"
import script from "./awards.vue?vue&type=script&lang=js"
export * from "./awards.vue?vue&type=script&lang=js"
import style0 from "./awards.vue?vue&type=style&index=0&id=822e5c88&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822e5c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('822e5c88')) {
      api.createRecord('822e5c88', component.options)
    } else {
      api.reload('822e5c88', component.options)
    }
    module.hot.accept("./awards.vue?vue&type=template&id=822e5c88&scoped=true", function () {
      api.rerender('822e5c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/awards.vue"
export default component.exports